export default "__VITE_ASSET__lNJzmQFL__"